// team_status_v1: หน้า "พนักงาน" — รวม 2 แท็บ: สถานะสด (owner) + รายงานเวลา (ทุกคน)
import { useEffect, useState, useRef } from 'react';
import API from '../api';
import { Users, RefreshCw } from 'lucide-react';
import TimeReport from './TimeReport'; // team_merge_v1: รายงานเวลาเป็นแท็บในหน้านี้

const PAGE_LABELS = {
  '/': 'แดชบอร์ด', '/inbox': 'กล่องข้อความ', 'Inbox': 'กล่องข้อความ', '/kpi': 'KPI',
  '/customers': 'ลูกค้า', '/invoices': 'บิล', '/products': 'สินค้า', '/channels': 'Channels',
  '/broadcast': 'บรอดแคสต์', '/quick-replies': 'Quick Replies', '/shifts': 'ตารางเวร',
  '/reports/time': 'รายงานเวลา', '/team': 'พนักงาน', '/settings': 'ตั้งค่า', '/ai': 'ผู้ช่วย AI', '/bot-training': 'เทรนบอท',
};
function pageLabel(p) {
  if (!p) return '—';
  if (PAGE_LABELS[p]) return PAGE_LABELS[p];
  const base = ('' + p).split('?')[0];
  return PAGE_LABELS[base] || base;
}
function fmtAgo(sec) {
  if (sec == null) return 'ยังไม่เคยเข้า';
  sec = Math.max(0, Math.floor(sec));
  if (sec < 45) return 'เมื่อสักครู่';
  if (sec < 3600) return Math.round(sec / 60) + ' นาทีที่แล้ว';
  if (sec < 86400) return Math.round(sec / 3600) + ' ชม.ที่แล้ว';
  return Math.round(sec / 86400) + ' วันก่อน';
}
function fmtDur(sec) {
  sec = Math.max(0, Math.floor(sec || 0));
  const h = Math.floor(sec / 3600), m = Math.round((sec % 3600) / 60);
  if (h > 0) return h + ' ชม. ' + m + ' นาที';
  return m + ' นาที';
}

// team_merge_v1 fix: แอปเก็บ user ที่ localStorage key 'tenant' (ไม่ใช่ 'user'); owner = ไม่ใช่ agent (ตรงกับ Layout)
function isOwnerUser() {
  try {
    const role = (JSON.parse(localStorage.getItem('tenant') || '{}').role) || '';
    return !['agent', 'staff', 'admin', 'viewer'].includes(role);
  } catch (e) { return true; }
}

function LiveStatus() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');
  const [updatedAt, setUpdatedAt] = useState(null);
  const timer = useRef(null);

  const load = () => API.get('/api/online/team')
    .then(r => { setRows(r.data || []); setErr(''); setUpdatedAt(new Date()); })
    .catch(e => setErr(e.response?.status === 403 ? 'เฉพาะเจ้าของร้านเท่านั้นที่ดูสถานะสดได้' : 'โหลดข้อมูลไม่สำเร็จ'))
    .finally(() => setLoading(false));

  useEffect(() => {
    load();
    timer.current = setInterval(load, 15000);
    return () => clearInterval(timer.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onlineCount = rows.filter(r => r.online).length;
  const activeAgents = rows.filter(r => r.is_active);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12, marginBottom: 16 }}>
        <p style={{ fontSize: 13, color: '#64748b', margin: 0 }}>ดูว่าใครกำลังทำงานอยู่แบบเรียลไทม์ (อัปเดตทุก 15 วินาที)</p>
        <button onClick={load} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 14px', background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600, fontSize: 13 }}>
          <RefreshCw size={14} /> รีเฟรช
        </button>
      </div>

      <div style={{ display: 'flex', gap: 12, marginBottom: 20, flexWrap: 'wrap' }}>
        <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 12, padding: '14px 20px', minWidth: 140 }}>
          <div style={{ fontSize: 28, fontWeight: 800, color: '#16a34a' }}>{onlineCount}</div>
          <div style={{ fontSize: 13, color: '#15803d' }}>🟢 ออนไลน์ตอนนี้</div>
        </div>
        <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 12, padding: '14px 20px', minWidth: 140 }}>
          <div style={{ fontSize: 28, fontWeight: 800, color: '#475569' }}>{activeAgents.length}</div>
          <div style={{ fontSize: 13, color: '#64748b' }}>👥 พนักงานที่เปิดใช้</div>
        </div>
      </div>

      {err && <div style={{ background: '#fef2f2', color: '#dc2626', padding: 14, borderRadius: 10, fontSize: 14 }}>{err}</div>}
      {loading && !rows.length && <div style={{ color: '#94a3b8', padding: 24, textAlign: 'center' }}>กำลังโหลด...</div>}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 12 }}>
        {rows.map(r => (
          <div key={r.id} style={{ background: '#fff', borderRadius: 12, padding: 16, boxShadow: '0 1px 4px rgba(0,0,0,0.06)', borderLeft: `4px solid ${r.online ? '#16a34a' : '#cbd5e1'}`, opacity: r.is_active ? 1 : 0.6 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
              <span style={{ width: 10, height: 10, borderRadius: '50%', background: r.online ? '#16a34a' : '#cbd5e1', flex: '0 0 auto', boxShadow: r.online ? '0 0 0 3px #16a34a22' : 'none' }} />
              <span style={{ fontWeight: 700, fontSize: 15, color: '#1e293b', flex: 1 }}>{r.name}</span>
              {!r.is_active && <span style={{ fontSize: 11, background: '#f1f5f9', color: '#94a3b8', padding: '2px 8px', borderRadius: 10 }}>ปิดใช้งาน</span>}
              {r.online
                ? <span style={{ fontSize: 11, background: '#dcfce7', color: '#16a34a', padding: '2px 8px', borderRadius: 10, fontWeight: 700 }}>ออนไลน์</span>
                : <span style={{ fontSize: 11, background: '#f1f5f9', color: '#94a3b8', padding: '2px 8px', borderRadius: 10 }}>ออฟไลน์</span>}
            </div>

            <div style={{ fontSize: 13, color: '#64748b', marginBottom: 12, minHeight: 18 }}>
              {r.online
                ? <>👁️ กำลังดู <b style={{ color: '#334155' }}>{pageLabel(r.current_page)}</b></>
                : <>🕒 เห็นครั้งล่าสุด {fmtAgo(r.last_seen_ago)}</>}
            </div>

            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              <div style={{ flex: 1, minWidth: 78, background: '#f8fafc', borderRadius: 8, padding: '8px 10px' }}>
                <div style={{ fontSize: 11, color: '#94a3b8' }}>⏱️ ทำงานวันนี้</div>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#1e293b' }}>{fmtDur(r.worked_today)}</div>
              </div>
              <div style={{ flex: 1, minWidth: 70, background: '#f8fafc', borderRadius: 8, padding: '8px 10px' }}>
                <div style={{ fontSize: 11, color: '#94a3b8' }}>💬 ตอบวันนี้</div>
                <div style={{ fontSize: 13, fontWeight: 700, color: r.replied_today > 0 ? '#0ea5e9' : '#1e293b' }}>{r.replied_today || 0} แชท</div>
              </div>
              <div style={{ flex: 1, minWidth: 90, background: '#f8fafc', borderRadius: 8, padding: '8px 10px' }}>
                <div style={{ fontSize: 11, color: '#94a3b8' }}>↩️ ตอบล่าสุด</div>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#1e293b' }}>{r.last_reply_ago == null ? '—' : fmtAgo(r.last_reply_ago)}</div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {!loading && !err && rows.length === 0 && (
        <div style={{ background: '#fff', borderRadius: 12, padding: 48, textAlign: 'center', color: '#94a3b8' }}>ยังไม่มีพนักงานในระบบ</div>
      )}
      {updatedAt && <div style={{ textAlign: 'right', fontSize: 11, color: '#cbd5e1', marginTop: 14 }}>อัปเดตล่าสุด {updatedAt.toLocaleTimeString('th-TH')}</div>}
    </div>
  );
}

export default function TeamStatus() {
  const isOwner = isOwnerUser(); // สถานะสด = เฉพาะเจ้าของร้าน (ไม่ใช่ agent)
  const [tab, setTab] = useState(isOwner ? 'live' : 'time');

  const TABS = [];
  if (isOwner) TABS.push({ k: 'live', label: '🟢 สถานะสด' });
  TABS.push({ k: 'time', label: '🕐 รายงานเวลา' });

  return (
    <div>
      <h2 style={{ fontSize: 22, fontWeight: 700, color: '#1e293b', margin: '0 0 16px', display: 'flex', alignItems: 'center', gap: 8 }}>
        <Users size={22} /> พนักงาน
      </h2>

      {TABS.length > 1 && (
        <div style={{ display: 'flex', gap: 8, marginBottom: 18, flexWrap: 'wrap' }}>
          {TABS.map(t => (
            <button key={t.k} onClick={() => setTab(t.k)}
              style={{ padding: '8px 18px', borderRadius: 8, fontWeight: 700, fontSize: 14, cursor: 'pointer',
                border: tab === t.k ? '1px solid #4f46e5' : '1px solid #e5e7eb',
                background: tab === t.k ? '#eef2ff' : '#fff', color: tab === t.k ? '#4f46e5' : '#475569' }}>
              {t.label}
            </button>
          ))}
        </div>
      )}

      {tab === 'live' && isOwner && <LiveStatus />}
      {tab === 'time' && <TimeReport />}
    </div>
  );
}
